import moment from 'moment/src/moment';

export default {
    jobTitle(state) {
        return state.job.job_title || '';
    },

    companyName(state) {
        return state.job.company_name || '';
    },

    primaryCompanyName(state) {
        return state.job.primary_brand_name || '';
    },

    locationLabel(state) {
        return state.job.location_label || '';
    },

    categoryLabel(state) {
        return state.job.category_label || '';
    },

    occupationLabel(state) {
        return state.job.occupation_label || '';
    },

    classifications(state) {
        return state.job.classification_relationship || '';
    },
    jobBody(state) {
        return state.job.body || '';
    },

    jobTypeLabel(state) {
        return state.job.job_type_label || '';
    },

    postedAt(state) {
        const date = state.job.activates_at;
        return state.is_apply_enabled ? moment.utc(date).local().format('D MMM YYYY') : '';
    },

    isPrivateListing(state) {
        return state.job.brand_is_hidden;
    },
};
